import API from '../Api/api.js';

import { commonBackendCall, getConfig } from '../Api/common.js';
import {
  GET_APPLICATION_STATUS_REQUEST,
  GET_APPLICATION_STATUS_SUCCESS,
  GET_APPLICATION_STATUS_FAILURE,
  GET_ROLE_STATUS_REQUEST,
  GET_ROLE_STATUS_SUCCESS,
  GET_ROLE_STATUS_FAILURE,
  GET_APPLICATION_LOG_REQUEST,
  GET_APPLICATION_LOG_SUCCESS,
  GET_APPLICATION_LOG_FAILURE,
  SET_CURRENT_ROLE_TITLE,
  PATCH_APPLICATION_REMIND_REQUEST,
  PATCH_APPLICATION_REMIND_SUCCESS,
  PATCH_APPLICATION_REMIND_FAILURE,
  PATCH_APPLICATION_ESCALATE_REQUEST,
  PATCH_APPLICATION_ESCALATE_SUCCESS,
  PATCH_APPLICATION_ESCALATE_FAILURE,
  GET_APPLICATION_COMPLETED_TASK_LIST_REQUEST,
  GET_APPLICATION_COMPLETED_TASK_LIST_SUCCESS,
  GET_APPLICATION_COMPLETED_TASK_LIST_FAILURE,
} from '../constants/ApplicationStatus';

export function setCurrentRoleTitle(value) {
  return (dispatch) => {
    dispatch({
      type: SET_CURRENT_ROLE_TITLE,
      payload: {
        value,
      },
    });
  };
}
export function getApplicationStatus(applicationID, roleID) {
  return commonBackendCall(
    GET_APPLICATION_STATUS_REQUEST,
    GET_APPLICATION_STATUS_SUCCESS,
    GET_APPLICATION_STATUS_FAILURE,
    API.get(`applications/status/${applicationID}/${roleID}`, getConfig()),
  );
}

export function getApplicationLog(applicationID, roleID) {
  return commonBackendCall(
    GET_APPLICATION_LOG_REQUEST,
    GET_APPLICATION_LOG_SUCCESS,
    GET_APPLICATION_LOG_FAILURE,
    API.get(`applications/track/${applicationID}/${roleID}`, getConfig()),
  );
}

export function getRole(roleID) {
  return commonBackendCall(
    GET_ROLE_STATUS_REQUEST,
    GET_ROLE_STATUS_SUCCESS,
    GET_ROLE_STATUS_FAILURE,
    API.get(`applications/roles/${roleID}`, getConfig()),
  );
}

export function patchApplicationRemind(applicationID, applicationTasklogID, obj) {
  return commonBackendCall(
    PATCH_APPLICATION_REMIND_REQUEST,
    PATCH_APPLICATION_REMIND_SUCCESS,
    PATCH_APPLICATION_REMIND_FAILURE,
    API.patch(`applications/reminders/${applicationID}/${applicationTasklogID}`, obj, getConfig()),
  );
}

export function patchApplicationEscalate(applicationID, applicationTasklogID, obj) {
  return commonBackendCall(
    PATCH_APPLICATION_ESCALATE_REQUEST,
    PATCH_APPLICATION_ESCALATE_SUCCESS,
    PATCH_APPLICATION_ESCALATE_FAILURE,
    API.patch(`applications/escalate/${applicationID}/${applicationTasklogID}`, obj, getConfig()),
  );
}

export function getApplicationCompletedTaskList(applicationID, roleID) {
  return commonBackendCall(
    GET_APPLICATION_COMPLETED_TASK_LIST_REQUEST,
    GET_APPLICATION_COMPLETED_TASK_LIST_SUCCESS,
    GET_APPLICATION_COMPLETED_TASK_LIST_FAILURE,
    API.get(`applications/completed-task-list/${applicationID}/${roleID}`, getConfig()),
  );
}